<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="热气球配置" @back="goBack" /></span>

          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:rewardSuperBalloonEdit:add']" type="primary" @click="dialogVisible = true">添加等级</el-button>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择类型">
                <el-select v-model="levelFormData.type" style="width: 150px" placeholder="请选择">
                  <el-option
                    v-for="item in conditionType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="数值">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="getLabelName(tabItem.label)" @tab-remove="delCond">
            <template #label>
              <div>
                {{ getLabelName(tabItem.label) }}
                <i v-if="!checkFormData(tabItem.label)" v-permisaction="['config:rewardSuperBalloonEdit:del']" class="el-icon-circle-close" style="margin-left:5px;font-size: 14px" @click="delCond(tabItem.label)" />
              </div>
            </template>

            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="选择类型">
                  <el-select v-model="tabItem.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label)}">
                    <el-option
                      v-for="item in conditionType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="数值范围">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                            <el-option
                              v-for="item in groups"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            />
                          </el-select>
                        </el-form>
                      </div>
                      <el-form>
                        <el-table :data="scoreItem.data[0].rewards" border stripe>
                          <el-table-column prop="stage" label="倍率区间">
                            <template v-slot:default="scope">
                              <el-input v-model.number="scope.row.start" placeholder="开始" style="width: 46%" />
                              -
                              <el-input v-model.number="scope.row.end" placeholder="结束" style="width: 46%" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="stage" label="配置">
                            <template v-slot:default="scope">
                              <el-button type="text" style="margin-left: 16px;" @click="drawer[tabItem.label][scoreItem.group_name][scope.$index].visible = true">
                                配置
                              </el-button>
                              <el-drawer
                                title="配置"
                                size="800px"
                                :visible.sync="drawer[tabItem.label][scoreItem.group_name][scope.$index].visible"
                                :direction="direction"
                                :before-close="(d) => {return handleClose(d, tabItem.label,scoreItem.group_name, scope.$index )}"
                              >
                                <el-form :inline="true">
                                  <el-row v-for="(r, i) in scope.row.list" :key="i">
                                    <el-form-item label="阶段" style="margin-top: 10px;">
                                      <el-input v-model.number="r.stage" style="width: 100px;" placeholder="阶段" />
                                    </el-form-item>
                                    <el-form-item label="图片ID" style="margin-top: 10px;">
                                      <el-input v-model.number="r.imgType" style="width: 100px;" placeholder="图片类型" />
                                    </el-form-item>
                                    <el-form-item label="权重" style="margin-top: 10px;">
                                      <el-input v-model.number="r.weight" style="width: 100px;" placeholder="权重" />
                                    </el-form-item>
                                    <el-form-item label="奖励" style="margin-top: 10px;">
                                      <ActReward :value="r.prize" />
                                    </el-form-item>
                                    <el-form-item style="margin-top: 10px;">
                                      <el-button v-permisaction="['config:rewardSuperBalloonEdit:del']" type="danger" @click="removeConfig(tabItem.label,scoreItem.group_name,scope.$index, i)">删除</el-button>
                                    </el-form-item>
                                  </el-row>
                                  <el-button v-permisaction="['config:rewardSuperBalloonEdit:add']" style="margin-top: 5px" type="primary" @click="addConfig(tabItem.label,scoreItem.group_name, scope.$index)">+</el-button>
                                </el-form>
                              </el-drawer>
                            </template>
                          </el-table-column>
                          <el-table-column prop="stage" label="操作">
                            <template v-slot:default="scope">
                              <el-button v-permisaction="['config:rewardSuperBalloonEdit:del']" type="danger" @click="delEvent1(tabItem.label,scoreItem.group_name ,scope.$index)">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                        <div style="margin-top: 10px">
                          <el-button type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                          <el-button v-permisaction="['config:rewardSuperBalloonEdit:add']" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
                          <el-button v-if="scoreItem.data[0].id > 0" :disabled="isOnline === 1" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name, scoreItem.data[0].id)">删除</el-button>
                        </div>
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <el-card class="box-card">
        <el-form ref="extraData" :model="extraData" :inline="true">
          <el-form-item label="移动类型" style="margin-top: 10px;">
            <el-select v-model.number="extraData.moveType" placeholder="请选择">
              <el-option
                v-for="item in moveTypeArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="速度" style="margin-top: 10px;">
            <el-input-number v-model.number="extraData.speed" :max="100" style="width: 130px;" placeholder="速度" />
          </el-form-item>
          <el-form-item v-for="(item, index) in extraData.outPut" :key="index" :label="outPutLabel[index]" style="margin-top: 10px;">
            <el-input v-model.number="extraData.outPut[index]" style="width: 110px;" :placeholder="outPutLabel[index]" />
          </el-form-item>
          <el-form-item label="气球权重" style="margin-top: 10px;">
            <el-input v-model.number="extraData.showPv" style="width: 110px;" placeholder="气球权重" />
          </el-form-item>
          <el-form-item style="margin-top: 10px;">
            <el-button type="primary" :disabled="isOnline === 1" @click="extraSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getChessBoardType, getRewardType } from '@/api/config/slot'
import {
  delActivityFirstRewardCfg,
  exportActivityRewardCfg, getActivityList,
  getActivityRewardCfg, getConditionTypesList, importActivityRewardCfg, updateActivityExtraData,
  updateActivityRewardCfg
} from '@/api/config/activity-cfg'
import { getSku } from '@/api/config/shop-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getRewardListForType } from '@/utils'
import ActReward from '@/components/Reward/act.vue'
export default {
  name: 'RewardSuperBalloonEdit',
  components: { ActReward },
  data() {
    return {
      isOnline: 0,
      loading: false,
      aid: 0,
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      outPutLabel: ['', '气球1权重', '气球2-3权重', '气球4-6权重'],
      extraData: {
        moveType: 1,
        speed: 0,
        outPut: {
          '1': 0,
          '2': 0,
          '3': 0
        },
        showPv: 0
      },
      shopSku: [],
      visibleArr: {},
      moveTypeArr: [
        {
          'value': 1,
          'label': '上'
        }, {
          'value': 2,
          'label': '下'
        }],
      buyType: [{ 'value': 1, 'label': '金币' }, { 'value': 2, 'label': '付费' }],
      coinType: [
        { label: 'money1', value: 'money1' },
        { label: 'money2', value: 'money2' },
        { label: 'money3', value: 'money3' },
        { label: 'money4', value: 'money4' },
        { label: 'money5', value: 'money5' },
        { label: 'money6', value: 'money6' }
      ],
      drawer: {},
      drawerReward: {},
      direction: 'rtl',
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      conditionType: [],
      actType: '',
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0,
        type: 'level'
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      defaultReward: ['1', '2', '3', '14', '15']
    }
  },
  created() {
    // this.getSkuList()
    this.getConditionTypeData()
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
    this.getGroup()
  },
  methods: {
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    priceChange(v, levelName, scoreName, index) {
      let sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          sku = item.sku
        }
      })
      this.formData[levelName][scoreName].data[0].rewards[index].sku = sku
    },
    getConditionTypeData() {
      getConditionTypesList({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.conditionType.push({ 'label': res.data[i], 'value': i })
          }
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivityRewardCfg({ type: this.actType, name: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivityRewardCfg({ id: this.aid, type: this.actType }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose2(done, levelName, scoreName, index) {
      this.drawerReward[levelName][scoreName][index].visible = false
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
      this.drawerReward[levelName][scoreName][index].visible = false
    },
    onSubmit(noTips = false, condSub = false) {
      const data = JSON.stringify(this.formData)
      console.log('data', data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        this.levelActiveName = i
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [type, minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          console.log('activeName', this.activeName)
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          const _formdata = scoreItem.data[0]
          console.log('_formdata', _formdata)
          for (const i in _formdata.rewards) {
            const _reward = _formdata.rewards[i]
            if (_reward.start > _reward.end) {
              this.msgError('倍率最小值不能大于最大值')
              return
            }

            for (const k in _reward.list) {
              const list = _reward.list[k]
              if (list.stage <= 0) {
                this.msgError('气球个数不能小于0')
                return
              }
            }
          }

          // if (condSub && scoreItem.data[0].rewards.length <= 0) {
          if (scoreItem.data[0].rewards.length <= 0) {
            this.msgError('空数据不能提交')
            return
          }

          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            shushu: [],
            type: type
          }

          const condition1 = {
            start: 0,
            end: 0,
            shushu: scoreItem.group,
            type: 'shushu'
          }

          postFormDataCondition[key] = [condition, condition1]
          console.log('条件 ', postFormDataCondition)
          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data[0]
          }

          const _data = scoreItem.data[0]
          // _data.condition = key
          _data.aid = this.aid
          const stage = {}
          stage[key] = condition
          _data.stage = key
          _postData.push(_data)
        }
      }

      const _post = Object.assign([], _postData)
      for (const k in _post) {
        const val = _post[k]
        for (const rk in val.rewards) {
          const reward = val.rewards[rk]
          const listObj = {}
          let i = 0
          for (const l in reward.list) {
            i++
            listObj[i] = reward.list[l]
          }
          _post[k].rewards[rk].list = listObj
        }
      }

      console.log('post', _post)
      const postCondition = JSON.stringify({ aid: this.aid, condition: postFormDataCondition })
      _postData = JSON.stringify(_post)
      console.log('postCondition', postCondition)
      console.log('_postData', _postData)
      updateActivityRewardCfg({ type: this.actType, name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.tabPane = []
      this.formData = []
      getActivityRewardCfg({ id: this.aid }).then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond.condition
        for (const i in cond) {
          const val = cond[i][0]
          const val1 = cond[i][1]
          const levelName = val.type + '-' + val.start + '-' + val.end
          const scoreName = val1.shushu.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.drawer, levelName)) {
            this.$set(this.drawer, levelName, {})
            this.$set(this.drawerReward, levelName, {})
          }

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.drawer[levelName], scoreName)) {
            this.$set(this.drawer[levelName], scoreName, [])
            this.$set(this.drawerReward[levelName], scoreName, [])
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val1.shushu,
            'group_name': scoreName,
            'group_bak': val1.shushu,
            data: [{ rewards: [] }]
          })

          for (const ii in data) {
            const _event = data[ii]
            if (_event.stage === i) {
              _event.rewards.forEach((r, index) => {
                this.drawer[levelName][scoreName].push({ visible: false })
                const arr = []
                for (const i in r.list) {
                  arr.push(r.list[i])
                  this.drawerReward[levelName][scoreName].push({ visible: false })
                }
                _event.rewards[index].list = arr
              })
              this.$set(this.formData[levelName][scoreName], 'data', [_event])
              console.log('data', this.formData[levelName][scoreName])
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              type: val.type,
              bak_type: val.type,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }
          this.tabPane.forEach((item, index) => {
            if (index === 0) {
              this.levelActiveName = item.label
            }
          })
        }
      })

      getActivityList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          const data = res.data.list[0]
          this.extraData = data.extraData
          if (!this.extraData.outPut) {
            this.extraData.outPut = {
              '1': 0,
              '2': 0,
              '3': 0
            }
          }
        }
      })
    },
    levelChangeType(newVal, levelName) {
      // 是否存在相同类型
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === levelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })

      if (fileIndex === -1) {
        this.msgError('修改失败')
        return
      }

      const oldTabPane = this.tabPane[fileIndex]
      const oldLevelName = oldTabPane.label
      const newLabelName = newVal + '-' + oldTabPane.min_level + '-' + oldTabPane.max_level
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === newLabelName) {
          this.msgError('当前类型配置已经存在')
          return
        }
      }
      oldTabPane.label = newLabelName
      this.tabPane[fileIndex] = oldTabPane
      this.levelActiveName = newLabelName
      if (Object.prototype.hasOwnProperty.call(this.formData, oldLevelName)) {
        const oldData = this.formData[oldLevelName]
        Vue.delete(this.formData, oldLevelName)
        this.$set(this.formData, newLabelName, oldData)
      }
      // 修改弹窗
      const oldVisle = this.drawer[oldLevelName]
      Vue.delete(this.drawer, oldLevelName)
      this.$set(this.drawer, newLabelName, oldVisle)

      // 修改弹窗
      const oldVisleReward = this.drawerReward[oldLevelName]
      Vue.delete(this.drawerReward, oldLevelName)
      this.$set(this.drawerReward, newLabelName, oldVisleReward)
    },
    levelChange(newVal, isMin, type, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = type + '-' + bakMin + '-' + bakMax
      let newLevelName = ''
      if (isMin) {
        newLevelName = type + '-' + newVal + '-' + bakMax
      } else {
        newLevelName = type + '-' + bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.drawer[oldLevelName]
      Vue.delete(this.drawer, oldLevelName)
      this.$set(this.drawer, newLevelName, oldVisle)

      const oldVisleReward = this.drawerReward[oldLevelName]
      Vue.delete(this.drawerReward, oldLevelName)
      this.$set(this.drawerReward, newLevelName, oldVisleReward)

      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addEvent1(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[index].config.push({
        aid: 1,
        reward: [{
          state: 1,
          stepnum: 1,
          prize: [
            {
              id: 1,
              num: 1,
              skin: 0,
              rtype: 2,
              type: 2,
              is_ts: 0
            }],
          progressBarId: 1,
          stageSpins: 1
        }],
        stage: []
      })
    },
    delEvent1(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[0].rewards = this.formData[levelName][scoreName].data[0].rewards.filter((item, key) => {
        return index !== key
      })

      let count = 0
      this.formData[levelName][scoreName].data[0].rewards.forEach((res, index) => {
        count++
        this.formData[levelName][scoreName].data[0].rewards[index].stage = count
      })
    },
    addEventReward(levelName, scoreName, index, i) {
      console.log(this.formData[levelName][scoreName].data[index].config[i])
      let propsId = 14
      if (this.formData[levelName][scoreName].data[index].config[i].type === 3) {
        propsId = 1
        if (this.formData[levelName][scoreName].data[index].config[i].reward.length >= 1) {
          return
        }
      }
      this.formData[levelName][scoreName].data[index].config[i].reward.push({
        propsId: propsId,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    addEvent(levelName, scoreName) {
      this.drawer[levelName][scoreName].push({ visible: false })
      this.formData[levelName][scoreName].data[0].rewards.push({
        start: 0,
        end: 0,
        list: []
      })
      console.log(this.drawerReward[levelName][scoreName])
    },
    delEvent(levelName, scoreName, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delActivityFirstRewardCfg({ id: id }).then(res => {
            if (res.code === 200) {
              // this.formData[levelName][scoreName].data = []
              this.$delete(this.formData[levelName], scoreName)
              // this.msgSuccess(res.msg)
              this.onSubmit(true)
              // this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })
        this.$set(this.drawer[score.level_name], scoreTag, [])
        this.$set(this.drawerReward[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push({ aid: 0, stage: [], rewards: [] })

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.type + '-' + this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        // this.msgError('等级已经存在')
        // return
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      }

      this.tabPane.push({
        'label': levelName,
        'type': this.levelFormData.type,
        'bak_type': this.levelFormData.type,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.drawer, levelName, {})
      // 初始化弹窗
      this.$set(this.drawerReward, levelName, {})
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData(ucType) {
      getRewardType({ data: ucType }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            if (this.defaultReward.includes(i)) {
              this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
            }
          }
        }
      })
    },
    addConfig(levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards[index].list.push(
        {
          stage: 0,
          imgType: 0,
          weight: 1,
          prize: []
        }
      )
      this.drawerReward[levelName][groupName].push({ visible: false })
    },
    addReward(levelName, groupName, index, key) {
      this.formData[levelName][groupName].data[0].rewards[index].list[key].prize.push(
        {
          id: 1,
          num: 1,
          skin: 0,
          rtype: 2,
          type: 14,
          is_ts: 0
        }
      )
    },
    removeReward(levelName, groupName, index, key, idx) {
      this.formData[levelName][groupName].data[0].rewards[index].list[key].prize = this.formData[levelName][groupName].data[0].rewards[index].list[key].prize.filter((item, k) => {
        return idx !== k
      })
    },
    delReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].list = this.formData[levelName][groupName].data[index].list.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      console.log('newGroupName', newGroupName)
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.drawer[levelName][oldGroupName]
      this.$delete(this.drawer[levelName], oldGroupName)
      this.$set(this.drawer[levelName], newGroupName, oldVisible)
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    removeConfig(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[0].rewards[index].list = this.formData[levelName][groupName].data[0].rewards[index].list.filter((item, key) => {
        return i !== key
      })
    }, getLabelName(label) {
      const arr = label.split('-')
      let typeName = ''
      this.conditionType.forEach((item) => {
        if (item.value === arr[0]) {
          typeName = item.label
        }
      })
      return typeName + '-Lv:' + arr[1] + '-' + arr[2]
    }, mtTypeChange(v, levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards[index].sku = ''
    }, getRewardList(prize) {
      return getRewardListForType(prize, this.rewardType)
    }, delCond(label) {
      this.$confirm('此操作将永久删除该条件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabPane = this.tabPane.filter(item => {
          return item.label !== label
        })

        this.onSubmit(false, true)
      })
    },
    checkFormData(label) {
      let count = 0
      for (const i in this.formData[label]) {
        const val = this.formData[label][i]
        count += val.data[0].rewards.length
      }

      if (count > 0) {
        return true
      }

      return false
    },
    extraSubmit() {
      const data = JSON.stringify(this.extraData)
      console.log('extraSubmit', data)
      updateActivityExtraData({ name: this.aid, type: this.actType, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
